export default __webpack_public_path__ + "locales/hy-AM/ChangePasswordDialog.json?hash=dbfc360b1dd3e15981dbb38890dbc033";